module.exports = __webpack_public_path__ + "static/media/fb-logo-hover.9bdb198b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/fb-logo-hover.svg
 ** module id = 1308
 ** module chunks = 0
 **/